import React, { lazy } from "react";

const LazyEditPayment = lazy(() => import("./EditPayment"));

const EditPayment = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode },
) => <LazyEditPayment {...props} />;

export default EditPayment;
